import React from 'react'
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

export const Verification = () => {

    return (
        <div>
            <img className='img-fluid gst-software-main-banner' src="./assets/images/Identity Management Solution.jpg" alt="" />


            <div className="container section-5-gst-software mt-5 p-3 text-center">

                <div className="bg-light">
                    <div className="container section5 mt-5 p-3 text-center">
                        <h1 className='section2-heading m-3'>Identity Management Solution</h1>
                        {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis doloremque numquam esse voluptates unde incidunt molestias.</p> */}
                        {/* <img className='img-fluid rounded-2' src="assets/images/identity.jpg" alt="hello.jpg" /> */}
                        <div className="section5-cards mt-5">
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Background Verification-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Background Verification-White.png' />
                                <h5 className='section5-card-text mt-3'>Background Verification</h5>
                            </div>
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Police Verification-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Police Verification-White.png' />
                                <h5 className='section5-card-text mt-3'>Police Verification</h5>
                            </div>
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Residence Verification-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Residence Verification-White.png' />
                                <h5 className='section5-card-text mt-3'>Residence Verification</h5>
                            </div>
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Employment Verification-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Employment Verification-White.png' />
                                <h5 className='section5-card-text mt-3'>Employment Verification</h5>
                            </div>
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Criminal Recode Check-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Criminal Recode Check-White.png' />
                                <h5 className='section5-card-text mt-3'>Criminal Recode Check</h5>
                            </div>
                            <div className="card section-5-card mt-4">
                                <img className='service-card-img' alt='services' src='./assets/images/PNG -Icons/Education Verification-Red.png' />
                                <img className='service-card-img-white' alt='services' src='./assets/images/PNG -Icons/Education Verification-White.png' />
                                <h5 className='section5-card-text mt-3'>Education Verification</h5>
                            </div>


                        </div>
                        <div className='ms-5 mt-5 text-center'>
                        <Stack spacing={20} direction="row">
                            <Link to='/contact-us'><Button variant="contained" >Interested - ?</Button></Link>
                        </Stack>
                        </div>
                        
                    </div>
                </div>
            </div>



        </div>
    )
}
